import { FC } from 'react'

import classes from './Block.module.scss'

interface Props {
  id: string
}

export const Block: FC<Props> = ({ children, id }) => (
  <div aria-live="polite" className={classes.root} id={id}>
    {children}
  </div>
)
